module.exports = __webpack_public_path__ + "public/img/energy3.6cc916ef.png";